import { render, staticRenderFns } from "./AirboxCard.vue?vue&type=template&id=4fb5caa0"
import script from "./AirboxCard.vue?vue&type=script&lang=js"
export * from "./AirboxCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports